/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Box, Button, Stepper, Step, StepLabel } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import AcademicSubjects from "./AcademicSubjects";
import Goals from "./MentorGoals";
import MajorCategories from "./MajorCategories";
import theme from "../Styles/StudentBackgroundStyle";
import { useDispatch, useSelector } from "react-redux";
import { postQuestionsData } from "../../store/studentSlice";
import { setNestedStep } from "../../store/commonSlice";
import { isEmpty } from "../../utils/constants";
import MentorSchool from "./MentorSchool";
import WarningPopUp from "../common/WarningPopUp";
import en from '../../nls/en.json';

const cssObj = {
  "& .MuiStepConnector-root": {
    left: "calc(-50% + 7px)",
    right: "calc(50% + 7px)",
  },
  "& .MuiStepLabel-labelContainer": {
    display: "none",
  },
  "& .MuiStepConnector-line": {
    borderTopWidth: "4px",
    display: "none",
  },
  "& .MuiStepIcon-root": {
    backgroundColor: "#999999",
    height: "4px",
    borderRadius: "4px"
  },
  "& .MuiSvgIcon-root circle": {
    display: "none",
  },
  "& .MuiStepIcon-text": {
    display: "none",
  },
  "& .MuiStepIcon-root.Mui-active": {
    backgroundColor: "#1468A2",
  },
  "& .Mui-completed .MuiStepIcon-root": {
    backgroundColor: "#1468A2",
  },
  mb: 5,
}

const getInnerSteps = () => ["Step 1", "Step 2", "Step 3", "Step 4"];

const getInnerStepContent = (stepInner, data, getAcademicSubjects, getGoals, getMajorCategories, getSchool) => {
  switch (stepInner) {
    case 0:
      return <AcademicSubjects getAcademicSubjects={getAcademicSubjects} data={ data?.data?.ACADEMIC_BACKGROUND?.find(item => item?.sub_category_name === "FAVOURITE_SUBJECTS_IN_SCHOOL") } />;
    case 1:
      return <MajorCategories getMajorCategories={getMajorCategories} data={ data?.data?.ACADEMIC_BACKGROUND?.find(item => item?.sub_category_name === "MAJOR_CATEGORIES") } />;
    case 2:
      return <Goals getGoals={getGoals} data={ data?.data?.ACADEMIC_BACKGROUND?.find(item => item?.sub_category_name === "COLLEGE_CONTACT_HELP") } />;
    case 3:
      return <MentorSchool getSchool={getSchool} step={stepInner} />;
    default:
      return null;
  }
};

const MentorAcadamicHistory = (data) => {

  const dispatch = useDispatch();
  const { loggedInUserId } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { isNestedstepCompleted } = useSelector(({ common }) => common);
  const [activeStep, setactiveStep] = React.useState(0);
  const stepsInner = getInnerSteps();
  const handleNextInner = () => setactiveStep((prevActiveStep) => prevActiveStep + 1);

  // Nested forms data
  const [academicSubjects, setAcademicSubjects] = useState({});
  const [school, setSchool] = useState({});
  const [goals, setGoals] = useState({});
  const [majorCategories, setMajorCategories] = useState({});

  // Nested callback function.
  const getAcademicSubjects = (data) => setAcademicSubjects(data);
  const getSchool = (data) => setSchool(data);
  const getGoals = (data) => setGoals(data);
  const getMajorCategories = (data) => setMajorCategories(data);

  const [openDialog, setOpenDialog] = useState(false);
  const handleDialogOpen = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const nestedPostCall = () => {

    if (activeStep === 0 && !academicSubjects.length) {
      handleDialogOpen();
      return;
    } else if (activeStep === 1 && !majorCategories.length) {
      handleDialogOpen();
      return;
    } else if (activeStep === 2 && !goals.length) {
      handleDialogOpen();
      return;
    // } else if ( activeStep === 3 && !school?.length ){
    //   handleDialogOpen();
    //   return;
    }
    
    const academicSubjectsQuestionId = data?.data?.ACADEMIC_BACKGROUND?.find(item => item?.sub_category_name === "FAVOURITE_SUBJECTS_IN_SCHOOL")?.question_id;
    const majorCategoriesQuestionId = data?.data?.ACADEMIC_BACKGROUND?.find(item => item?.sub_category_name === "MAJOR_CATEGORIES")?.question_id;
    const goalsQuestionId = data?.data?.ACADEMIC_BACKGROUND?.find(item => item?.sub_category_name === "COLLEGE_CONTACT_HELP")?.question_id;
    const schoolQuestionId = data?.data?.MENTOR_BACKGROUND?.find(item => item?.sub_category_name === "SCHOOLS_YOU_ARE_INTERESTED")?.question_id;

    const payLoad = { "user_id": loggedInUserId, "responses": [] };
    if (!isEmpty(academicSubjects)) {
      payLoad.responses.push({ "question_id": academicSubjectsQuestionId, "selected_options": academicSubjects });
    }
    if (!isEmpty(school)) {
      payLoad.responses.push({ "question_id": schoolQuestionId, "selected_options": ['2b44a50e-d990-11ee-af3b-325096b39f47'], master_data_id: school?.map(item => item.id) });
    }
    if (!isEmpty(goals)) {
      payLoad.responses.push({ "question_id": goalsQuestionId, "selected_options": goals });
    }
    if (!isEmpty(majorCategories)) {
      payLoad.responses.push({ "question_id": majorCategoriesQuestionId, "selected_options": majorCategories })
    }

    if (!isEmpty(payLoad.responses)) {
      dispatch(postQuestionsData(payLoad));
    }

    handleNextInner();

    const afterNestedFinalStep = activeStep === stepsInner.length - 1 ? true : false
    // Nested final step completed.
    if (afterNestedFinalStep) {
      dispatch(setNestedStep(isNestedstepCompleted + 1));
    }
  }

  useEffect(()=>{
    if(data?.myRef){
      data.myRef.current.scrollTop = 0;
    }
  },[activeStep]);

  return (
    <ThemeProvider theme={theme}>
      <Box className="inner-stepper">
        <Box variant="form">
          <Stepper
            alternativeLabel
            activeStep={activeStep}
            sx={cssObj}
          >
            {stepsInner.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {getInnerStepContent(activeStep, data, getAcademicSubjects, getGoals, getMajorCategories, getSchool)}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "32px",
            }}
          >
            <WarningPopUp
              openDialog={openDialog}
              handleCloseDialog={handleCloseDialog}
              dialogMessage={'Please select at least one option'}
            />
            <Button
              variant="contained"
              onClick={() => { nestedPostCall() }}
              sx={{ mr: 1 }}>
              {en.NEXT}
            </Button>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MentorAcadamicHistory;
